import hasInvalidMappings from 'app/beta-editor/utils/hasInvalidMappings';
import isValidFields from 'app/beta-editor/utils/isValidFields';
import isValidSample from 'app/beta-editor/utils/isValidSample';
import filterCannotContinue from 'app/beta-editor/utils/filterCannotContinue';
import { isFilter } from 'app/service/utils';
import { isPathNode } from 'app/beta-editor/utils/PathUtils';
import {
  createEditorUrl,
  isFlowTemplate,
} from 'app/beta-editor/utils/FlowUtils';

import { RequiredBehaviors } from 'app/beta-editor/pages/types';

interface FilterBehavior extends RequiredBehaviors {
  isApplicable(): boolean;
}

const filterBehavior: FilterBehavior = {
  href(props) {
    const { flow, node, pageKey } = props;
    const isTemplate = isFlowTemplate(flow.nodes);
    return createEditorUrl({
      flowId: flow.id,
      nodeId: node.id,
      pageKey,
      isTemplate,
    });
  },

  label(props) {
    const { node } = props;
    if (hasInvalidMappings(node)) {
      return 'Options may be out of date.';
    }
    return 'Filter Setup & Testing';
  },

  menuLabel(props) {
    const filterLabel = filterBehavior.label(props);
    return filterBehavior.status(props) === 'alert'
      ? `${filterLabel} (needs attn)`
      : filterLabel;
  },

  crumbLabel(props) {
    return filterBehavior.label(props);
  },

  data() {
    return undefined;
  },

  status({ node, flow }) {
    // I don't think invalid mappings are ever filled for
    // filter steps, so we can probably delete this, but
    // wanted to leave this just in case for now.
    if (hasInvalidMappings(node)) {
      return 'alert';
    } else if (isValidFields(node, flow) && isValidSample(node, flow)) {
      return 'success';
    } else if (!filterCannotContinue(node)) {
      return 'success';
    }
    return ''; // not edited
  },

  isApplicable() {
    return true;
  },

  visible(props) {
    const { node } = props;
    return !isPathNode(node) && isFilter(node.type_of);
  },

  isClickable() {
    return true;
  },

  isLocked() {
    return false;
  },
};

export default filterBehavior;
